import type { NuxtApp } from '#app'
import {fetchInit} from '~/composables/api'


export default defineNuxtPlugin({
  name: 'api',
  enforce: 'pre',
  async setup(nuxtApp) {
    const $api = fetchInit(nuxtApp as NuxtApp)
    return {
      provide: {
        'api': $api,
      }
    }
  }
})